// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2dCiF","title":"Images90_title__33ZTl","images":"Images90_images__9Uyv7"};